import { useCallback as e, useRef as t, useState as n } from "react";
//#region src/hooks/usePropertySelection.ts
var r = () => {
	let [r, i] = n(null), a = t(null);
	return {
		selectedProperty: r,
		selectProperty: e((e) => {
			a.current = e, i(e);
		}, []),
		clearSelectedProperty: e(() => {
			a.current = null, i(null);
		}, []),
		consumeSelection: e(() => {
			let e = a.current;
			if (!e) return null;
			let t = `[Selected Property: "${e.title}" (id: ${e.id}, lat: ${e.latitude}, lng: ${e.longitude})]`;
			return a.current = null, i(null), {
				prefix: t,
				property: e
			};
		}, [])
	};
};
//#endregion
export { r as usePropertySelection };
